import { Navigate, Route, Routes } from 'react-router';
import { AppShell } from '@/components/layout/app-shell';
import { Spinner } from '@/components/shared/loading';
import { Analytics } from '@/pages/app/analytics';
import { ApiKeys } from '@/pages/app/api-keys';
import { AppLayout } from '@/pages/app/app-layout';
import { AuditLog } from '@/pages/app/audit-log';
import { Credentials } from '@/pages/app/credentials';
import { Installations } from '@/pages/app/installations';
import { Overview } from '@/pages/app/overview';
import { Sends } from '@/pages/app/sends';
import { Settings } from '@/pages/app/settings';
import { TestSend } from '@/pages/app/test-send';
import { AppsList } from '@/pages/apps-list';
import { CreateApp } from '@/pages/create-app';
import { Login } from '@/pages/login';
import { Ops } from '@/pages/ops';
import { Resources } from '@/pages/resources';
import { useAuth } from '@/providers/auth-provider';

export function App() {
  const { user, ready } = useAuth();
  if (!ready) return <div className="grid min-h-svh place-items-center"><Spinner /></div>;
  if (!user) {
    return (
      <Routes>
        <Route path="*" element={<Login />} />
      </Routes>
    );
  }
  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route index element={<AppsList />} />
        <Route path="apps/new" element={<CreateApp />} />
        <Route path="apps/:appId" element={<AppLayout />}>
          <Route index element={<Overview />} />
          <Route path="credentials" element={<Credentials />} />
          <Route path="api-keys" element={<ApiKeys />} />
          <Route path="test-send" element={<TestSend />} />
          <Route path="sends" element={<Sends />} />
          <Route path="installations" element={<Installations />} />
          <Route path="analytics" element={<Analytics />} />
          <Route path="audit" element={<AuditLog />} />
          <Route path="settings" element={<Settings />} />
        </Route>
        <Route path="ops" element={<Ops />} />
        <Route path="resources" element={<Resources />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
